import React from 'react';

export default function Header(props) {
    return (
        <header className="row block center">
            <div>
                <a href="#/"><h1>Ostoskärry</h1></a>
            </div>
        </header>
    );
}